// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "stChH_registerFormState", inline: true };
const loggerMsgs = {
  stateChange: (CHANGE) => [`register-form state:`, CHANGE],
  error_noStateChange: () => ["No change to state provided."],
  error_invalidStateValue: (VALUE) => [`invalid state value: ${VALUE}`],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_registerFormState(CHANGES) {
  if (!("registerFormState" in CHANGES)) return this.logger("error", loggerMsgs.error_noStateChange(), "error", logArgs);

  // Setup...
  const { registerFormState } = CHANGES;
  const { registerForm } = this.ref;
  this.logger("state-change", loggerMsgs.stateChange(registerFormState), "default", { ...logArgs, inline: false });

  // Execute nested is_hidden state-change...
  if ("is_hidden" in registerFormState) {
    const { is_hidden } = registerFormState;
    registerForm.setAttribute("data-is-hidden", is_hidden);
  }

  // Execute nested backBtn_is_hidden state-change...
  if ("backBtn_is_hidden" in registerFormState) {
    const { backBtn_is_hidden } = registerFormState;
    const backBtn = registerForm.querySelector("[g-ref='backToContinueOrJoinBtns']");
    if (backBtn) backBtn.setAttribute("data-is-hidden", backBtn_is_hidden);
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
